import { ISvgProps, Svg } from '@components';
import { memo } from 'react';

export const CartIcon = memo<ISvgProps>((props, { className }) => (
  <Svg className={className} width="30.906" height="30.468" viewBox="0 0 30.906 30.468" {...props}>
    <path
      id="Union_14"
      data-name="Union 14"
      d="M592.872-6357.881a2.5,2.5,0,0,1,2.5-2.5,2.5,2.5,0,0,1,2.5,2.5,2.5,2.5,0,0,1-2.5,2.5A2.5,2.5,0,0,1,592.872-6357.881Zm-13,0a2.5,2.5,0,0,1,2.5-2.5,2.5,2.5,0,0,1,2.5,2.5,2.5,2.5,0,0,1-2.5,2.5A2.5,2.5,0,0,1,579.871-6357.881Zm4.566-3.479a6.446,6.446,0,0,1-6.4-5.693l-1.774-15.082a1.288,1.288,0,0,0-1.279-1.136H574.7a1.29,1.29,0,0,1-1.289-1.291,1.289,1.289,0,0,1,1.289-1.289h.287a3.867,3.867,0,0,1,3.838,3.414l.055.453h8.71a1.289,1.289,0,0,1,1.289,1.289,1.288,1.288,0,0,1-1.289,1.289h-8.407l1.213,10.313h15.775a3.867,3.867,0,0,0,3.806-3.181l.165-.915a1.29,1.29,0,0,1,1.5-1.04,1.289,1.289,0,0,1,1.039,1.5l-.165.915a6.445,6.445,0,0,1-6.343,5.3H580.791a3.866,3.866,0,0,0,3.646,2.579H597.9a1.289,1.289,0,0,1,1.29,1.289,1.289,1.289,0,0,1-1.29,1.289Zm11.026-13.474h-.042a2.415,2.415,0,0,1-1.734-.774l-2.08-2.165a1.289,1.289,0,0,1,.035-1.822,1.287,1.287,0,0,1,1.822.037l2,2.087,6.649-6.657a1.291,1.291,0,0,1,1.822,0,1.29,1.29,0,0,1,0,1.824l-6.752,6.758a2.416,2.416,0,0,1-1.715.713Z"
      transform="translate(-573.408 6385.851)"
      fill="#3477eb"
    />
  </Svg>
));

CartIcon.displayName = 'CartIcon';

export default CartIcon;
